export enum ORDER_FINANCIAL_OPTIONS {
  AUTHORIZED = 'AUTHORIZED',
  PAID = 'PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING= 'PENDING',
  REFUNDED = 'REFUNDED',
  VOIDED = 'VOIDED'
}

export interface IOrderFinancialStatus {
  status: ORDER_FINANCIAL_OPTIONS;
  label: string;
  color: string;
}

export const ORDER_FINANCIAL_STATUS_OPTIONS = [
  {
    status: ORDER_FINANCIAL_OPTIONS.AUTHORIZED,
    label: 'Authorized',
    color: 'primary'
  },
  {
    status: ORDER_FINANCIAL_OPTIONS.PAID,
    label: 'Paid',
    color: 'primary'
  },
  {
    status: ORDER_FINANCIAL_OPTIONS.PARTIALLY_PAID,
    label: 'Partially Paid',
    color: 'warn'
  },
  {
    status: ORDER_FINANCIAL_OPTIONS.PARTIALLY_REFUNDED,
    label: 'Partially Refunded',
    color: 'primary'
  },
  {
    status: ORDER_FINANCIAL_OPTIONS.PENDING,
    label: 'Pending',
    color: 'secondary'
  },
  {
    status: ORDER_FINANCIAL_OPTIONS.REFUNDED,
    label: 'Refunded',
    color: 'primary'
  },
  {
    status: ORDER_FINANCIAL_OPTIONS.VOIDED,
    label: 'Voided',
    color: 'warn'
  }
];
